import * as actionTypes from "../actions/actionTypes";

const initialState: {
  providerType: { name: string; id: string }[];
  providerSpeciality: { name: string; id: string }[];
  error: boolean;
} = {
  providerType: [],
  providerSpeciality: [],
  error: false,
};
const findProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROVIDER_TYPE: {
      return {
        ...state,
        providerType: action.providerType,
        error: false,
      };
    }
    case actionTypes.FETCH_PROVIDER_TYPE_FAILED: {
      return {
        ...state,
        providerType: initialState.providerType,
        error: true,
      };
    }
    case actionTypes.SET_PROVIDER_SEPCIALITY: {
      return {
        ...state,
        providerSpeciality: action.providerSpeciality,
        error: false,
      };
    }
    case actionTypes.FETCH_PROVIDER_SEPCIALITY_FAILED: {
      return {
        ...state,
        providerSpeciality: initialState.providerSpeciality,
        error: true,
      };
    }
    default:
      return state;
  }
};
export default findProviderReducer;
